import { FlowType } from '@cash-web/protos/squareup/cash/plasma/flows/FlowProto.pb'
import { StatusResult } from '@cash-web/protos/squareup/franklin/status_result.pb'
import { BlockerType, FlowBlockerDescriptor, FlowData, getBlockerType } from '@cash-web/shared-flow-data-access-context'

import { FlowReducerAction, FlowState } from './hooks/flowReducer'
import { FlowResponse } from './middleware/utils'

export const DEFAULT_ERROR_MESSAGE = 'Oops, something went wrong. Please refresh the page and try again.'
export const getActiveBlocker = (skippedBlockers: BlockerType[], blockerDescriptors: FlowBlockerDescriptor[]) => {
  return blockerDescriptors.find(blockerDescriptor => {
    return !skippedBlockers.includes(getBlockerType(blockerDescriptor.blocker))
  })
}

export const getBlockerDescriptorsFromAction = (action: FlowReducerAction) => {
  if ('blockerDescriptors' in action) {
    return action.blockerDescriptors?.filter(isNotEmptyBlocker)
  }
  return undefined
}

const isNotEmptyFormBlocker = (blockerDescriptor: FlowBlockerDescriptor) => {
  const formBlocker = blockerDescriptor.blocker?.form
  return formBlocker == null || (formBlocker.elements != null && formBlocker.elements.length !== 0)
}

export const isNotEmptyBlocker = (blockerDescriptor: FlowBlockerDescriptor) => {
  return Object.keys(blockerDescriptor).length !== 0 && isNotEmptyFormBlocker(blockerDescriptor)
}

export const isFlowComplete = (data: FlowData | FlowState | FlowResponse) => {
  let blockerDescriptors: FlowBlockerDescriptor[] | undefined = []
  let statusResult: StatusResult | undefined

  if ('blockerDescriptors' in data) {
    blockerDescriptors = data.blockerDescriptors?.filter(isNotEmptyBlocker)
  }
  if ('responseContext' in data) {
    statusResult = data.responseContext?.status_result
  } else if ('response_context' in data) {
    blockerDescriptors = data.response_context?.scenario_plan?.blocker_descriptors?.filter(isNotEmptyBlocker)
    statusResult = data.response_context?.status_result
  }

  const hasNoBlockers = blockerDescriptors == null || blockerDescriptors.length === 0
  const hasNoStatusResult = statusResult == null

  return hasNoBlockers && hasNoStatusResult
}

export function createInitiationData(flowType: FlowType, params?: Record<string, unknown>): string {
  if (!params || Object.keys(params).length === 0) {
    return flowType
  }

  const encodedParams = btoa(JSON.stringify(params))

  return `${flowType}?params_type=json&params=${encodedParams}`
}

export function isFlowType(flowTypeString: string): flowTypeString is FlowType {
  return Object.keys(FlowType).includes(flowTypeString)
}

export function parseFlowTypeFromInitiationData(initiationData?: string) {
  const likeyFlowType = initiationData?.match(/^[^?]+/)?.[0]
  return likeyFlowType && isFlowType(likeyFlowType) ? likeyFlowType : undefined
}

export function getFlowType(data: Partial<FlowData>): FlowType | undefined {
  if ('flow' in data) {
    return data.flow?.flowType ?? parseFlowTypeFromInitiationData(data.flow?.initiationData)
  }
  return undefined
}
